<template>
    <component
        :is="elementTag"
        v-bind="attributes"
        :class="isLink ? linkClass : fallbackClass"
    >
        <slot />
    </component>
</template>
<script>
export default {
    props: {
        href: {
            type: String,
            required: false,
            default: null
        },
        fallbackHref: {
            type: String,
            required: false,
            default: null
        },
        disableLink: {
            type: Boolean,
            required: false,
            default: false
        },
        fallbackElement: {
            type: String,
            required: false,
            default: 'span'
        },
        fallbackClass: {
            type: String,
            required: false,
            default: ''
        },
        linkClass: {
            type: String,
            required: false,
            default: ''
        },
        target: {
            type: String,
            required: false,
            default: '_self'
        },
        type: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        isLink() {
            return !this.disableLink && this.validateLink(this.href);
        },
        elementTag() {
            if (this.isLink) {
                if (this.type === 'document') {
                    return 'nuxt-link';
                }
                return 'a';
            }
            return this.fallbackElement;
        },
        attributes() {
            if (this.isLink) {
                const href = this.type === 'document' 
                    ? {to: this.href} 
                    : {href: this.href};
                return {
                    ...href,
                    target: this.target,
                    ...(this.target === '_blank' && {rel: 'noopener noreferrer'})
                };
            }
            return {
                href: this.fallbackHref
            };
        }
    },
    methods: {
        validateLink(link) {
            const ERROR_URL = '/undefined';
            if (!link) {
                return false;
            }

            if (typeof link !== 'string') {
                link = this.$prismic.linkResolver(link);
            }

            return link !== ERROR_URL;
        }
    }
};
</script>